// @ts-nocheck
import React, { useMemo } from 'react';
import { Trans, t } from '@lingui/macro';
import { useRouter } from 'next/router'
import cn from 'classnames';
import Link from '../components/Link';

import SystemDailyDeal from '../components/SystemDailyDeal';
import SystemTimeDeal from '../components/SystemTimeDeal';
import SystemWdayDeal from '../components/SystemWdayDeal';
import SystemHotStation from '../components/SystemHotStation';
import SystemRouteOD from '../components/SystemRouteOD';
import SystemMovingTimeRange from '../components/SystemMovingTimeRange';
import SystemMovingTimeWday from '../components/SystemMovingTimeWday';
import SystemDailyHourDeal from '../components/SystemDailyHourDeal';
import getDateRange from '../utils/getDateRange';
import styles from './Overview.module.scss';
import { YEARLY_REPORT, MONTHLY_REPORT } from '../utils/static';
import {
    overviewUrl, activityUrl, odUrl,
} from '../utils/urls';

import {
    isMobile as isMobileFn, stopRunningTranslate, genYYYYMM, getWindowWidth, format,
} from '../utils';

const Overview = ({
    reportType,
    stationlist,
    dateDeal,
    stationDeal,
    timeDeal,
    totalWdayDeal,
    routeRank,
    weatherDaily,
    yyyymm,
    sortedDateRange,
    numOfWeekDayInThisDateRange,
    movingTimeRange,
    movingTimeWday,
    hourlyDeal,
    locale,
    addPinIds,
    config,
    geo,
    year,
    month,
}) => {
    const [
        isMobile,
        width,
        widthHalf
    ] = useMemo( () => [
        isMobileFn(),
        getWindowWidth(),
        getWindowWidth() / 2
    ], []);
    const router = useRouter();

    const generateMonthSelect = () => {
        if (config.dateRange.length === 1) return null;

        return (
            <div className="clearfix">
                <div className={styles.selectGroup}>
                    <span>
                        <Trans id="system.showRange" />
                        ：
                    </span>
                    <select className={cn('form-control', styles.monthSelect)} name="month" value={yyyymm} onChange={changeMonth}>
                        <option value="all">
                            {t({ id: 'system.allMonth' })}
                        </option>
                        {sortedDateRange.map(({ year, month }) => (
                            <option value={genYYYYMM(year, month)} key={`${year}${month}`}>{format({ date: new Date(year, month - 1), locale })}</option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }


    const changeMonth = (e) => {
        const yyyymm = e.target.value;
        if (yyyymm !== 'all') {
            const year = yyyymm.substring(0, 4);
            const month = yyyymm.substring(4);
            const url = overviewUrl({
                locale, system: config.system, year, month,
            });
            router.push(url);
        }
    }

    return (
        <div className="container center">
            <h2 style={{ marginTop: '20px' }}>
                {config.name}
                {config.stopRunning
                    ? (
                        <div className={styles.stopOperation}>
                        (
                            {stopRunningTranslate(locale)}
                        )
                        </div>
                    )
                    : null}
            </h2>
            <p>
                <span style={{ paddingRight: '3px' }}>
                    <Trans id="system.datasource" />
                :
                </span>
                {reportType === YEARLY_REPORT
                    ? getDateRange(config.dateRange, locale)
                    : format({ date: new Date(year, month - 1), locale })}
            </p>
            <div>
                {generateMonthSelect()}
                <SystemDailyDeal
                    reportType={reportType}
                    weatherDaily={weatherDaily}
                    hasWeather={false}
                    width={width}
                    data={dateDeal}
                />
                {reportType === MONTHLY_REPORT
                    ? (
                        <SystemDailyHourDeal
                            isMobile={isMobile}
                            locale={locale}
                            width={width}
                            data={hourlyDeal}
                        />
                    )
                    : null}
                <div className="row mb-5">
                    <div className="col-md-6">
                        <SystemWdayDeal
                            isMobile={isMobile}
                            numOfWeekDayInThisDateRange={numOfWeekDayInThisDateRange}
                            width={widthHalf}
                            data={totalWdayDeal}
                        />
                    </div>
                    <div className="col-md-6">
                        <SystemTimeDeal
                            config={config}
                            reportType={reportType}
                            width={widthHalf}
                            data={timeDeal}
                        />
                    </div>
                </div>
                <h3 className="system-head center">
                    <Trans id="system.tripDuration" />
                </h3>
                <div className="row mb-5">
                    <div className="col-md-9">
                        <SystemMovingTimeRange
                            isMobile={isMobile}
                            width={width}
                            data={movingTimeRange}
                        />
                    </div>
                    <div className="col-md-3">
                        <SystemMovingTimeWday
                            isMobile={isMobile}
                            locale={locale}
                            width={widthHalf}
                            data={movingTimeWday}
                        />
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-6">
                        <SystemHotStation
                            width={widthHalf}
                            data={stationDeal}
                            stationlist={stationlist}
                            addPinIds={addPinIds}
                            geo={geo}
                        />
                    </div>
                    <div className="col-md-6">
                        <SystemRouteOD
                            geo={geo}
                            width={width}
                            data={routeRank}
                            isMobile={isMobile}
                        />
                    </div>
                </div>
                <hr />
                <div style={{ marginBottom: '50px' }}>
                    <Link
                        href={activityUrl({
                            system: config.system, year, month,
                        })}
                    >
                        <a className="btn btn-info btn-next btn-lg">
                            <i className="fa fa-caret-right" style={{ paddingRight: '5px' }} />
                            <Trans id="nav.heatmap" />
                        </a>
                    </Link>
                    <Link
                        href={odUrl({
                            system: config.system, year, month,
                        })}
                    >
                        <a className="btn btn-info btn-next btn-lg">
                            <i className="fa fa-caret-right" style={{ paddingRight: '5px' }} />
                            <Trans id="nav.od" />
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Overview;